// extracted by mini-css-extract-plugin
module.exports = {"highlighter":"roomSelectionView_highlighter__2qNf8"};